import { render, staticRenderFns } from "./biller-list.vue?vue&type=template&id=2fe69536&"
import script from "./biller-list.vue?vue&type=script&lang=js&"
export * from "./biller-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports